import React, { useState, useEffect } from "react";
import Highlighter from "react-highlight-words";
import { ReactComponent as GESTOR } from "../../build/images/gestor.svg";
import VIDEO from "../../build/images/video.jpg";
import AUDIO from "../../build/images/audio.svg";
import FOTO from "../../build/images/foto.svg";
import DOC from "../../build/images/doc.svg";
import { Popover, Tooltippy } from "../../actions/Tippy";

function createJSON(item) {
  if(item){
      var mensagem_tratada = item.replace(/¿/gi, "\n");
      mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      let valor = 1
      try{
      mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada
      } catch(e){
          mensagem_tratada = item; 
      }
      return mensagem_tratada
  } 
}

const MessageContainer = ({
  positmessage1,
  message,
  mensagem_tratada,
  latinize,
  searchWords,
  dia,
  InfoUsers,
  ContactId,
  markstar2,
  isChecked,
  handleCheck,
  msgIndex,
  NovaMensagem,
  handleReply
}) => {
  const [msgsocket, setMsgsocket] = useState("");
  

  const author = message.author;
  const typemsg = message.typemsg;
  const infousers = InfoUsers;
  const contactid = ContactId;

  useEffect(() => {
    document.getElementById(`bubble-${msgIndex}`).children[0].children[0] &&
      setMsgsocket(
        document
          .getElementById(`bubble-${msgIndex}`)
          .children[0].children[0].innerText.trim()
          .replace(/\n|\r\n/gi, "¿")
      );
  }, [isChecked]);

  const handleDropClick = e => {
    e.preventDefault();
    document.getElementById("chat-wrapper").classList.add("active");
    handleCheck(
      isChecked,
      message,
      contactid,
      infousers,
      author,
      typemsg,
      msgsocket
    );
  };

  const renderPopover = (event,messageid) => (
    <div className="context-menu drop-forward" id="drop-forward">
      <ul className="context-menu__list">
        <li className="context-menu__item"><a className="context-menu__link responder-link" onClick={() => handleReply({messageid})}>Responder</a></li>
      </ul>
    </div>
  );

  return (
    <div className={positmessage1}>
      <div className="time">{dia}</div>
      <div className="message__container">
        <div
          className={`checkbox checkbox--checked ${
            positmessage1 !== "message right" ? "checkbox--checked-left" : ""
          }
          ${isChecked ? "active" : ""}
          `}
        >
          <div
            className="checkbox-container"
            onClick={() =>
              handleCheck(
                isChecked,
                message,
                contactid,
                infousers,
                author,
                typemsg,
                msgsocket
              )
            }
          >
            <div className="checkbox-item">
              <div className="check">
                <i className="material-icons">check</i>
              </div>
            </div>
          </div>
          <div className="bubble" id={message.messageid}>
            { 
              (() => {
                if(message.replyid > 0){
                var text = '';
                var array = []
                var posit = '';
                
                  if(NovaMensagem){
                    
                  array = NovaMensagem.filter(msg => parseInt(msg.messageid) === parseInt(message.replyid))

                  
                     // if(array.length !== 0 || array){
                      if(array.length !== 0 && array){
                        posit = array[0].author
                        if(array[0].typemsg !== '0' && array[0].typemsg !== '2'){
                          var url	= array[0].message
                          url = url.split("~¿");
                          url = url[2]
                          url = url.substring(url.lastIndexOf('.') + 1);
                          switch (url.toLowerCase()) {
                            case "jpeg":
                            case "png":
                            case "jpg": {
                                return (
                                  <a href={'#'+message.replyid}>
                                  <div className="reply-message active">
                                      <div className="reply-message__name">{posit === 'Me' ? 'Você':createJSON(ContactId.cliente)}</div>
                                        <div className="reply-message__text">
                                          <img src={FOTO} alt="" width="15" />   Imagem
                                        </div>
                                  </div>
                                </a>
                                );
                              }
                            case "pdf":
                              return (
                                <a href={'#'+message.replyid}>
                                  <div className="reply-message active">
                                      <div className="reply-message__name">{posit === 'Me' ? 'Você':createJSON(ContactId.cliente)}</div>
                                        <div className="reply-message__text">
                                          <img src={DOC} alt="" width="15" />   PDF
                                        </div>
                                  </div>
                                </a>
                              );
                            case "xls":
                              case "xlsx":
                              case "xlsm":
                              case "doc":
                              case "docx":
                              case "ppt":
                              case "pptx": {
                                return (
                                        <a href={'#'+message.replyid}>
                                          <div className="reply-message active">
                                              <div className="reply-message__name">{posit === 'Me' ? 'Você':createJSON(ContactId.cliente)}</div>
                                                <div className="reply-message__text">
                                                  <img src={DOC} alt="" width="15" />   DOC
                                                </div>
                                          </div>
                                        </a>
                                        );
                            }
                            case "wav":
                            case "mp3":
                            case "ogg":
                            case "mpeg": {
                            return (
                                      <a href={'#'+message.replyid}>
                                        <div className="reply-message active">
                                            <div className="reply-message__name">{posit === 'Me' ? 'Você':createJSON(ContactId.cliente)}</div>
                                              <div className="reply-message__text">
                                                <img src={AUDIO} alt="" width="12" />   Áudio
                                              </div>
                                        </div>
                                      </a>
                            );
                            }
                            case "mp4": {
                              return (
                                  <a href={'#'+message.replyid}>
                                    <div className="reply-message active">
                                        <div className="reply-message__name">{posit === 'Me' ? 'Você':createJSON(ContactId.cliente)}</div>
                                          <div className="reply-message__text">
                                            <img src={VIDEO} alt="" width="15" />   Vídeo
                                          </div>
                                    </div>
                                  </a>
                              );
                            }
                          }
                        }else{
                          text = array[0].message
                          if(text.length > 200)
                            text = text.substr(0,200)+'...';
                            text = text.replace(/¿/gi, "\n");
                            text = text.replace(/§/gi, "\r\n");
                            return (
                                    <a href={'#'+message.replyid}>
                                      <div className="reply-message active">
                                          <div className="reply-message__name">{posit === 'Me' ? 'Você':createJSON(ContactId.cliente)}</div>
                                          <div className="reply-message__text">{text}</div>
                                      </div>
                                    </a>
                              );
                        }
                      }
                 } 
                }
              })()
            }
            {positmessage1 === "message right" ? (
              ""
            ) : (
              
                (() => {
                    if('teste' === 're' &&  message.statusmsg !== 'error'){
                     return <Popover
                                      trigger="click"
                                      interactive={true}
                                      content={renderPopover()}
                                    >
                              <div className="forward-content">
                                <i
                                  className="material-icons tippy-context-forward tippy-context-menu"
                                  data-tippy-placement="bottom"
                                  data-template="drop-forward"
                                >
                                  keyboard_arrow_down
                                </i>
                              </div>
                            </Popover>
                    }
                  }
                )()
            )}
            {(() => {
              if (positmessage1 === "message gestor") {
                return (
                  <>
                    <div className="bubble-user-name">Gestor</div>
                    <div className="icon-gestor">
                      {(() => {
                        if (positmessage1 === "message gestor") {
                          if (message.typemon === "1") {
                            return <GESTOR />;
                          } else if (message.typemon === "2") {
                            return <GESTOR />;
                          } else if (message.typemon === "3") {
                            return <GESTOR />;
                          }
                        }
                      })()}
                      Gestor: {message.username}
                    </div>
                  </>
                );
              }
            })()}
            <div className="bubble-user-name">Atendente</div>
            <div
              className="text"
              id={`bubble-${msgIndex}`}
              style={{ whiteSpace: "pre-line" }}
            >
              <Highlighter
                searchWords={searchWords}
                textToHighlight={mensagem_tratada}
                sanitize={latinize}
              />
              <span className="text__end-spacing"></span>
            </div>
            <div className="bubble__info-content">
              <div
                className={
                  message.favorite === "true"
                    ? "fav fav--inside fav--right active"
                    : "fav fav--inside fav--right"
                }
              >
                <i
                  onClick={() =>
                    markstar2(
                      message.messageid,
                      InfoUsers.id,
                      message.favorite,
                      ContactId.idatendimento
                    )
                  }
                  className="material-icons fav-icon"
                >
                  {message.favorite === "true" ? "star" : "star_border"}
                </i>
              </div>
              <div className="bubble__info-content__time">
                {!message.datatime === true ? message.data : message.datatime}
              </div>
              {(() => {
                  if (positmessage1 !== "message left") {
                      if(message.statusmsg === 'error')
                            return (
                              <div
                                className={
                                  "message-info message-info--" + message.statusmsg
                                }
                              >
                                <i className="material-icons">error</i>
                              </div>
                            );
                      else  if(message.statusmsg === 'entregue')
                            return (
                              <div
                                className={
                                  "message-info"
                                }
                              >
                                <i className="material-icons">done_all</i>
                              </div>
                            ); 
                    else  if(message.statusmsg === 'visto')
                            return (
                              <div
                                className={
                                  "message-info message-info--visto"
                                }
                              >
                                <i className="material-icons">done_all</i>
                              </div>
                            ); 
                      else  
                        return (
                          <div
                            className={
                              "message-info"
                            }
                          >
                            <i className="material-icons">done</i>
                          </div>
                        ); 

                }
              })()}
            </div>
            {positmessage1 === "message right" && message.statusmsg !== 'error'? (
               (() => {
                if('teste' === 're'){
                 return <Popover
                          trigger="click"
                          interactive={true}
                          content={renderPopover()}
                        >
                          <div className="forward-content">
                            <i
                              className="material-icons tippy-context-forward tippy-context-menu"
                              data-tippy-placement="bottom"
                              data-template="drop-forward"
                            >
                              keyboard_arrow_down
                            </i>
                          </div>
                        </Popover>
                      }
                    }
                  )()
            ) : (
              ""
            )}

          {message.statusmsg !== 'error'? (
               (() => {
                 return <Popover
                          trigger="click"
                            interactive={true}
                            content={renderPopover(this, message.messageid)}
                          >
                            <div className="forward-content">
                              <i
                                className="material-icons tippy-context-forward tippy-context-menu"
                                data-tippy-placement="bottom"
                                data-template="drop-forward"
                              >
                                keyboard_arrow_down
                              </i>
                            </div>
                    </Popover>
                    }
                  )()
            ) : (
              ""
            )}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageContainer;
